<template>
  <div class="w100 pl20 pr20 pt20 pb20 qa-helper" v-loading="loading">
    <el-tabs v-model="activeTabName" type="card" >
      <el-tab-pane :label="item.label" :name="item.is" v-for="item in componentList" :key="item.is">
        <component :is="item.is" :ref="item.is"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import setting from '@/components/management/QAHelper/setting'
import statistics from '@/components/management/QAHelper/statistics'

export default {
  name: "QAHelper",
  data() {
    return {
      loading: false,
      activeTabName: 'statistics',
      componentList: [
        {is: 'statistics', label: '统计'},
        {is: 'setting', label: '问题设置'},
      ],
    };
  },
  components: {
    setting,
    statistics,
  },
  computed: {
  },
  watch: {},
  created() {
  },
  methods: {
    
  }
};
</script>

<style lang="less" scoped>
.qa-helper {
  /deep/ .el-tabs {
    height: 100%;
    .el-tabs__content {
      height: calc(100% - 55px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
</style>